import React from 'react';
import CookieConsent from 'react-cookie-consent';
// import { withRouter } from 'react-router-dom';

const mq = window.matchMedia('(max-width: 510px)');

const mqS = window.matchMedia('(max-width: 320px)');

const StyleProp = {
  //   background: '#93e1d8'

  background: '#861657',
  justifyContent: 'center',
  flexDirection: mq.matches ? 'column' : '',
  //   flexWrap: mq.matches ? 'wrap' : '',
  alignItems: mq.matches ? 'center' : ''
  //   maxHeight: '75px'
};

const ButtonProp = {
  //   display: 'none',
  //   color: '#861657',

  //   borderColor: '#861657',
  //   justifyContent: 'right',
  marginTop: mq.matches ? '0' : '8px',
  marginBottom: '8px',
  borderColor: '#93e1d8',
  color: '#93e1d8',
  borderRadius: '3px',
  padding: '8px',
  background: 'transparent',
  border: '1px solid',
  fontSize: '12px',
  fontFamily: 'miller-display, serif',
  fontWeight: '400',
  alignSelf: 'center',
  flex: mq.matches ? '1' : ''
};

const ContentProp = {
  //   display: 'none',
  marginTop: mq.matches ? '8px' : '5px',
  marginBottom: mq.matches ? '8px' : '5px',
  alignSelf: 'center',
  color: '#93e1d8',
  //   color: '#861657',
  fontSize: mq.matches ? '13px' : '14px',
  fontFamily: 'miller-display, serif',
  fontWeight: '400',
  flex: mq.matches ? '1' : ''
};

const CookieConsentComp = props => {
  return (
    <CookieConsent
      style={StyleProp}
      buttonStyle={ButtonProp}
      //   onAccept={() => props.history.push('/contact')}
      buttonText="I Understand"
      contentStyle={ContentProp}
      acceptOnScroll={true}
      acceptOnScrollPercentage={10}
    >
      {mqS.matches
        ? 'This website uses cookies.'
        : 'This website uses cookies to enhance your experience.'}
    </CookieConsent>
  );
};

export default CookieConsentComp;
// export default withRouter(CookieConsentComp);
